import { RootState } from "@app/redux/root-reducer";

export const selectLoginState = (store: RootState) => store.loginReducer.login;
export const selectSignUpState = (store: RootState) =>
  store.loginReducer.signUp;
export const selectForgotPasswordState = (store: RootState) =>
  store.loginReducer.forgotPassword;
export const selectResetPasswordState = (store: RootState) =>
  store.loginReducer.resetPassword;
export const selectVerifyOTPState = (store : RootState) => store.loginReducer.verifyOtp;
